import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@magic-item item-id, Название предмета на русском}
export const MagicItemPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'item'} params={{id}} title={title} className={linkClass('magic-item')}>
			<i>{title}</i>
		</Link>
	);
};
